import React from 'react';
import classNames from 'classnames';

import styles from './style.scss';


const EmptyBookCard = () => {
  return (
    <div className={classNames(styles.book, 'jest-empty-book-card')}>
      <div className={styles.bookCover} />
      <div className={styles.bookContent}>
        <div className={styles.title} />
        <div className={styles.name} />
        <div className={styles.description} />
        <div className={styles.info} />
      </div>
    </div>
  );
};

export default EmptyBookCard;
